import(/* webpackMode: "eager", webpackExports: ["GamePageClient"] */ "/opt/hotlistcasino/frontend/src/app/[lang]/games/[slug]/GamePageClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Breadcrumbs"] */ "/opt/hotlistcasino/frontend/src/components/Breadcrumbs.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FavoriteGameButton"] */ "/opt/hotlistcasino/frontend/src/components/FavoriteGameButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LocalizedLink"] */ "/opt/hotlistcasino/frontend/src/components/LocalizedLink.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MotionReveal"] */ "/opt/hotlistcasino/frontend/src/components/MotionReveal.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MotionStagger"] */ "/opt/hotlistcasino/frontend/src/components/MotionStagger.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SafeGameImage"] */ "/opt/hotlistcasino/frontend/src/components/SafeGameImage.tsx");
